import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permissions = route.data?.['permissions'];
  const required = Array.isArray(permissions) ? permissions : [permissions].filter(Boolean);

  if (!required.length) return true;

  return auth.user$.pipe(
    filter(user => user !== null),
    take(1),
    map(() => required.some((permission) => auth.hasPermission(permission))
      ? true
      : router.createUrlTree(['/dashboard'])),
  );
};
